import React, { Fragment, useState, useEffect } from "react";
import { slaService } from "../../services";
import { Chip } from "@material-ui/core";
import { Alarm, Warning } from "@material-ui/icons";
export const CaseRowSLAs = ({ caseDates, caseId, isPaused }) => {
    const [slas, setSlas] = useState([]);
    useEffect(() => {
        slaService.getAll().then(slaResponse => setSlas(slaResponse.data));
    }, []);
    if (!slas.length) {
        return React.createElement(Fragment, null);
    }
    const outstandingSlasAndDates = slas
        .map(sla => ({
        id: sla.id,
        name: sla.name,
        date: caseDates[`${sla.id}Date`],
        target: caseDates[`${sla.id}TargetDate`],
        daysRemaining: caseDates[`${sla.id}DaysRemaining`],
        isSLA: sla.isSLA,
    }))
        .filter(sla => sla.isSLA && sla.target && !sla.date);
    const breachingSLAs = outstandingSlasAndDates.filter(sla => sla.daysRemaining === 1);
    const breachedSLAs = outstandingSlasAndDates.filter(sla => sla.daysRemaining <= 0);
    // if no breaches, then show the next approaching sla
    const nextUpSLA = !breachedSLAs.length && !breachingSLAs.length
        ? outstandingSlasAndDates.sort((a, b) => a.daysRemaining - b.daysRemaining)[0]
        : undefined;
    return isPaused ? (React.createElement("span", { className: "sla-pill sla-pill-breaching", "data-test": "sla-paused" },
        React.createElement(Chip, { size: "small", label: "SLA paused", icon: React.createElement(Warning, null) }),
        "\u00A0")) : (React.createElement(Fragment, null,
        breachingSLAs.map(sla => (React.createElement("span", { key: sla.id, className: "sla-pill sla-pill-breaching", "data-test": "sla-breaching" },
            React.createElement(Chip, { size: "small", label: `${sla.name}: 1 day`, icon: React.createElement(Alarm, null) }),
            "\u00A0"))),
        breachedSLAs.map(sla => (React.createElement("span", { key: sla.id, className: "sla-pill sla-pill-breached", "data-test": "sla-breached" },
            React.createElement(Chip, { size: "small", label: `${sla.name}: ${sla.daysRemaining === 0
                    ? "today"
                    : sla.daysRemaining === -1
                        ? "1 day late"
                        : -1 * sla.daysRemaining + " days late"}`, icon: React.createElement(Alarm, null) }),
            "\u00A0"))),
        nextUpSLA && (React.createElement("span", { className: "sla-pill", "data-test": "sla-next" },
            React.createElement(Chip, { size: "small", label: `${nextUpSLA.name}: ${nextUpSLA.daysRemaining === -1 ? "1 day" : nextUpSLA.daysRemaining + " days"}`, icon: React.createElement(Alarm, null) }),
            "\u00A0"))));
};
